import { Base } from "../core/base.model";
import { TareaDiaria } from "./tareaDiaria.model";
import { TiempoTarea } from "./tiempoTarea.model";

export class CapturaManualSemanal extends Base {
  idUsuario: number;
  fechaInicioSemana: Date | string;
  fechaFinSemana: Date | string;
  tareas: TareaDiaria[];
  bloques: TiempoTarea[];
}
